import { zodResolver } from "@mantine/form";
import { clinicLocationDataSchema } from "beitary-shared";
import { z } from "zod";

const locationFormSchema = clinicLocationDataSchema;

export type LocationFormValues = z.infer<typeof locationFormSchema>;

export const rules = zodResolver(locationFormSchema);
